module.exports = __webpack_public_path__ + "static/1-shutterstock_514799557-63d8b2715dafa1bf18484776b8ea96a9.jpg";